import { ChangeDetectorRef, Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ThemeModeService } from 'src/app/_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { SitesService } from 'src/app/modules/users/services/sites.service';
import { SiteGet } from 'KiaLearn.Common/angular-common-libraries/projects/web-api-client/src/lib/generated/kia-sites-api-client';
import { APIService } from 'src/app/api';
import { AuthService } from '../../services/auth.service';
import { ExternalUserRequest } from 'KiaLearn.Common/angular-common-libraries/projects/web-api-client/src/lib/generated/kia-authentication-api-client';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-registration-step2',
  templateUrl: './user-registration-step2.component.html',
  styleUrls: ['./user-registration-step2.component.scss']
})
export class UserRegistrationStep2Component implements OnInit {
  @Input() title: string;
  @Input() accessKey: string;
  @Input() flowKey: string;
  detailsForm: FormGroup;
  sites: SiteGet[] = [];
  selectedSite: SiteGet;
  darkMode: boolean = false;
  isSubmitting: boolean = false;
  private subscriptions: Subscription[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private sitesService: SitesService,
    private cdr: ChangeDetectorRef,
    private modeService: ThemeModeService,
    private apiService: APIService,
    private authService: AuthService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.detailsForm = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(3)]],
      lastName: ['', [Validators.required, Validators.minLength(3)]],
      site: ['', Validators.required]
    });

    this.sitesService.getSitesByAccessKey(this.accessKey).then((result) => {
      this.sites = result;
      this.cdr.detectChanges();
    });

    this.subscriptions.push(this.modeService.mode.asObservable().subscribe((mode) => {
      this.darkMode = mode === 'dark';
    }));
  }

  onSiteChange(newSite: SiteGet) {
    this.selectedSite = newSite;
    this.detailsForm.get('site')?.setValue(newSite);
  }

  submitDetails(): void {
    if (this.detailsForm.valid) {
      this.isSubmitting = true;
      const flowString = sessionStorage.getItem(this.flowKey);
      if (flowString) {
        const flow = JSON.parse(flowString);

        // register the user
        let body: ExternalUserRequest = new ExternalUserRequest();
        body.email = flow.email;
        body.firstName = this.detailsForm.get('firstName')?.value;
        body.lastName = this.detailsForm.get('lastName')?.value;
        body.siteId = this.detailsForm.get('site')?.value?.id;

        this.apiService.getKiaAuthenticationApiClient().postExternalUser(body).then(async (result) => {
          await this.authService.loginWithAccessKey(body.email, result, this.accessKey);
          sessionStorage.removeItem(this.flowKey);
          this.activeModal.close();
          this.isSubmitting = false;
        }).catch((error) => { 
          this.activeModal.close();
          this.toastr.error("Something went wrong while registering the user.", "Registration Failed");
          this.isSubmitting = false;
        });
      }
    } else {
      this.toastr.error("Something went wrong while registering the user.", "Registration Failed");
    }
  }
}